import { memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { dateToString, getFullName } from '@/utils';
import { useGetParentPlacementsQuery } from '@/services/parent-api';
import Table from '@/components/table';

const columns = [
  {
    title: 'Child',
    key: 'child',
    render: (_, record) => <Link to={`/child/${record.childId}`}>{getFullName(record)}</Link>,
  },
  {
    title: 'Matched Date',
    dataIndex: 'matchedDate',
    render: (value) => dateToString(value),
  },
  {
    title: 'Placed Date',
    dataIndex: 'placedDate',
    render: (value) => dateToString(value),
  },
  {
    title: 'Removed Date',
    dataIndex: 'removeDate',
    render: (value) => dateToString(value),
  },
  {
    title: 'Note',
    dataIndex: 'note',
    ellipsis: true,
  },
];

const PlacementHistory = ({ parentId }) => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const pageNumber = queryParams.get('page') || 1;
  const { data, isFetching } = useGetParentPlacementsQuery({ parentId, pageNumber });

  return (
    <Table
      columns={columns}
      dataSource={data?.data}
      rowKey="childPlacementId"
      loading={isFetching}
      pageInfo={data}
      size="small"
    />
  );
};

export default memo(PlacementHistory);
